import Select from '../../../../../Form/src/jsx/Select';
import { LetterType, WordType } from '../../types/SharedTypes';
import FilterButton from '../atoms/FilterButton';

export type AlphabetFilterType = {
	words: Record<string, WordType[]>;
	getLabel: (key: string) => string;
	activeFilter: LetterType;
	onFilterChange: FilterChangeHandler;
};

export type FilterChangeHandler = (letter: LetterType) => void;

export default function AlphabetFilter(props: AlphabetFilterType) {
	const { words, activeFilter, onFilterChange, getLabel } = props;

	const handleFilterChange: FilterChangeHandler = (letter: LetterType) => {
		if (onFilterChange) {
			onFilterChange(letter);
		}
	};

	const onFilterButtonClick = (letter: LetterType) => {
		if (activeFilter === letter) {
			handleFilterChange(null);
		} else {
			handleFilterChange(letter);
		}
	};

	const selectOptions = [
		{ label: getLabel('overview_filter_all_button'), value: 'all' },
		...Object.keys(words)
			.filter((key) => words[key]?.length > 0)
			.map((key) => ({ label: key, value: key })),
	];

	const handleSelectChange = (value: string) => {
		onFilterChange(value === 'all' ? null : (value as LetterType));
	};

	return (
		<div className="glossary__filter" role="toolbar" aria-label={getLabel('overview_filter_aria_label')}>
			<Select
				label={getLabel('overview_filter_select_label')}
				name="letter"
				onChange={handleSelectChange}
				options={selectOptions}
				value={activeFilter || 'all'}
			/>
			<FilterButton
				key="all"
				ariaLabel={getLabel('overview_filter_all_button')}
				label={getLabel('overview_filter_all_button')}
				isActive={!activeFilter}
				onClick={() => handleFilterChange(null)}
			/>
			{Object.entries(words).map(([letter, words]) => {
				const hasEntries = Array.isArray(words) && words.length > 0;
				return (
					<FilterButton
						key={letter}
						ariaLabel={getLabel('overview_filter_button_aria_label').replace('%s', letter)}
						label={letter}
						disabled={!hasEntries}
						isActive={activeFilter === letter}
						onClick={() => onFilterButtonClick(letter)}
					/>
				);
			})}
		</div>
	);
}
